/**
 * Mock 會員資料
 * password 欄位在真實環境為 HASH，此處 demo 用明文方便測試
 *
 * @type {Array<{
 *   memberGuid: string, status: string,
 *   username: string, password: string,
 *   name: string, phone: string,
 *   address: { zipCode: number, address: string },
 *   createdAt: string
 * }>}
 */
const members = [
  {
    memberGuid: "MEMBER-20250312-001",
    status: "Normal",
    username: "leon.lai",
    password: "password123",
    name: "賴奇佑",
    phone: "0970-400-259",
    address: {
      zipCode: 248,
      address: "新北市五股區成泰路三段543巷15號2樓",
    },
    createdAt: "2024-01-01T12:00:00",
  },
  {
    memberGuid: "MEMBER-20250312-002",
    status: "Normal",
    username: "demo.user",
    password: "demo1234",
    name: "測試用戶",
    phone: "0912-345-678",
    address: {
      zipCode: 100,
      address: "台北市中正區重慶南路一段122號",
    },
    createdAt: "2024-02-15T08:00:00",
  },
  {
    memberGuid: "MEMBER-20250312-003",
    status: "Baned",
    username: "banned.user",
    password: "banned123",
    name: "封鎖帳號",
    phone: "0900-000-000",
    address: {
      zipCode: 220,
      address: "新北市板橋區中山路一段1號",
    },
    createdAt: "2024-03-01T10:00:00",
  },
];

export default members;
